import { useEffect } from 'react';
import { buildIframeUrl } from '../Popup/utils/iframeUtils';

interface UseProImagesRedirectProps {
  show: boolean;
  showProImagesInPopup: boolean | undefined;
  configJSON?: {
    proImagesUrl?: string;
    proMinLengthForImage?: number;
  };
  proNumber?: string;
  effectiveApiConfig?: any;
  onClose: () => void;
}

/**
 * Hook to handle redirect logic for ProImages component
 * - If feature flag is disabled and proImagesUrl exists, opens in new tab
 * - If feature flag is enabled but proImagesUrl doesn't exist and no API images, closes component
 */
export const useProImagesRedirect = ({
  show,
  showProImagesInPopup,
  configJSON,
  proNumber,
  effectiveApiConfig,
  onClose
}: UseProImagesRedirectProps) => {
  useEffect(() => {
    if (!show) return;

    // Wait for feature flags to load
    if (showProImagesInPopup === undefined) return;

    // If feature flag is disabled and proImagesUrl exists, open in new tab
    if (showProImagesInPopup === false && configJSON?.proImagesUrl) {
      const iframeUrl = buildIframeUrl(proNumber, configJSON);
      if (iframeUrl) {
        window.open(iframeUrl, '_blank');
      }
      onClose();
      return;
    }

    // Handle unique case: feature flag enabled but proImagesUrl doesn't exist and no API images
    if (showProImagesInPopup === true && !configJSON?.proImagesUrl && !effectiveApiConfig) {
      // No content to show in popup, just close
      onClose();
    }
  }, [show, showProImagesInPopup, configJSON, proNumber, effectiveApiConfig, onClose]);
};
